import { Injectable, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { E404Component } from './e404/e404.component';
import { AuthGuard } from '../../_helpers/auth.guard';
import { ProfileComponent } from './profile/profile.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { OrderComponent } from './order/order.component';
import { OrderPaymentComponent } from './order-payment/order-payment.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { ParentalGateComponent } from '../authentication/parental-gate/parental-gate.component';
import { ParentalGateGuard } from '../../_helpers/parental.guard';

export enum CorePaths {
  profile = "profile",
  subscription = "subscriptions",
  order = "subscriptions/create",
  orderTransaction = "transactions",
  accessDenied = "access-denied",
  parentalGate = "parental-gate"
}

@Injectable({ providedIn: 'root' })
export class PaymentQueryParamGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const transactionId = route.queryParamMap.get('transactionId');

    if (transactionId) {
      return true;
    }

    return false;
  }
}

const routes: Routes = [
  {
    path: CorePaths.profile,
    component: ProfileComponent,
    canActivate: [AuthGuard, ParentalGateGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: CorePaths.subscription,
    component: SubscriptionComponent,
    canActivate: [AuthGuard, ParentalGateGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: CorePaths.order,
    component: OrderComponent,
    canActivate: [AuthGuard, ParentalGateGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: CorePaths.orderTransaction,
    component: OrderPaymentComponent,
    canActivate: [AuthGuard, ParentalGateGuard, PaymentQueryParamGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: CorePaths.accessDenied,
    component: AccessDeniedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: CorePaths.parentalGate,
    component: ParentalGateComponent,
    canActivate: [AuthGuard, ParentalGateGuard]
  },
  {
    path: '**',
    component: E404Component,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
